"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTime = void 0;

var _react = _interopRequireWildcard(require("react"));

var _pickers = require("@material-ui/pickers");

var _jalaali = _interopRequireDefault(require("@date-io/jalaali"));

var _momentJalaali = _interopRequireDefault(require("moment-jalaali"));

var _useGlobalStyles = require("../../styles/global/useGlobalStyles");

var _dateTime = require("./dateTime.style");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _svg = require("../../svg");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

_momentJalaali["default"].loadPersian({
  dialect: "persian-modern",
  usePersianDigits: true
});

var DateTime = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  (0, _useGlobalStyles.useGlobalStyles)();
  var classes = (0, _dateTime.useStyles)(props);
  var from = props.from,
      to = props.to;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      fromDate = _useState2[0],
      setFromDate = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      toDate = _useState4[0],
      setToDate = _useState4[1];

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      fromDate: fromDate,
      toDate: toDate,
      setToDate: setToDate,
      setFromDate: setFromDate
    };
  }, [ref, fromDate, toDate]);
  (0, _react.useEffect)(function () {
    return setFromDate(from ? new Date(from * 1000) : null);
  }, [from]);
  (0, _react.useEffect)(function () {
    return setToDate(to ? new Date(to * 1000) : null);
  }, [to]);

  var fDDltIcn = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: "15px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: function onClick() {
      setFromDate(null);
      props.onChangeFrom(null);
    },
    style: {
      margin: "-0.5em"
    },
    disabled: props === null || props === void 0 ? void 0 : props.disabled
  }, _svg.deleteIcon));

  var tDDltIcn = /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginLeft: "15px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: function onClick() {
      setToDate(null);
      props.onChangeTo(null);
    },
    disabled: props === null || props === void 0 ? void 0 : props.disabled,
    style: {
      margin: "-0.5em"
    }
  }, _svg.deleteIcon));

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.dateBox)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(classes.label, " ").concat(props.size === "lg" ? classes.lgLabel : classes.smLabel)
  }, props.label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(classes.dateBorder, " ").concat(classes[props.size])
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "50%",
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _jalaali["default"],
    locale: "fa"
  }, fromDate && fDDltIcn, /*#__PURE__*/_react["default"].createElement(_pickers.DatePicker, {
    okLabel: "\u062A\u0623\u06CC\u06CC\u062F",
    cancelLabel: "\u0644\u063A\u0648",
    clearLabel: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646",
    handleDateChange: true,
    labelFunc: function labelFunc(date) {
      return date ? date.format("jYYYY/jMM/jDD") : "";
    },
    value: fromDate || null,
    onChange: function onChange(e) {
      e._d.setHours(0, 0, 0, 0);

      var date = e._d.getTime() / 1000;
      setFromDate(e);
      props.onChangeFrom(date);
    },
    KeyboardButtonProps: {
      "aria-label": "change date"
    },
    getYearText: function getYearText(e) {},
    animateYearScrolling: true,
    autoOk: true,
    disabled: props === null || props === void 0 ? void 0 : props.disabled // orientation="landscape"
    // openTo="date"
    ,
    placeholder: props.oncePlaceholder // InputProps={fromDate && fDDltIcn}

  }))), !props.single && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: classes.line
  }, "-"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "50%",
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _jalaali["default"],
    locale: "fa"
  }, toDate && tDDltIcn, /*#__PURE__*/_react["default"].createElement(_pickers.DatePicker, {
    okLabel: "\u062A\u0623\u06CC\u06CC\u062F",
    cancelLabel: "\u0644\u063A\u0648",
    clearLabel: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646",
    handleDateChange: true,
    labelFunc: function labelFunc(date) {
      return date ? date.format("jYYYY/jMM/jDD") : "";
    },
    value: toDate || null,
    onChange: function onChange(e) {
      e._d.setHours(0, 0, 0, 0);

      var date = e._d.getTime() / 1000;
      setToDate(e);
      props.onChangeTo(date);
    },
    KeyboardButtonProps: {
      "aria-label": "change date"
    },
    getYearText: function getYearText(e) {},
    animateYearScrolling: true,
    autoOk: true // orientation="landscape"
    // openTo="date"
    ,
    placeholder: props.twicePlaceholder,
    disabled: props === null || props === void 0 ? void 0 : props.disabled // InputProps={toDate && tDDltIcn}

  }))))), props.invalidFeedback && /*#__PURE__*/_react["default"].createElement("p", {
    className: "".concat(classes.invalidFeedback, " ").concat(props.size === "lg" ? classes.lg : classes.sm)
  }, props.invalidFeedback));
});
exports.DateTime = DateTime;
DateTime.propTypes = {
  /** Label */
  label: _propTypes["default"].string,

  /** From date (Must be timeStamp) */
  from: _propTypes["default"].number,

  /** To date (Must be timeStamp) */
  to: _propTypes["default"].number,

  /** Size */
  size: _propTypes["default"].oneOf(["sm", "lg"]),

  /** Single date time  */
  single: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,

  /** First place holder  */
  oncePlaceholder: _propTypes["default"].string,

  /** Twice place holder  */
  twicePlaceholder: _propTypes["default"].string,

  /** Show error  */
  invalidFeedback: _propTypes["default"].string
};
DateTime.defaultProps = {
  label: "انتخاب تاریخ",
  size: "sm",
  single: false,
  oncePlaceholder: 'از تاریخ',
  twicePlaceholder: 'تا تاریخ',
  invalidFeedback: null
};